/**
 * "Acting as" a partner company (White Knight owners only).
 *
 * POST /api/platform/organizations/:id/act-as returns a 30-minute token; while it is
 * stored here every API call carries it as X-WK-Act-As and the backend runs the call
 * inside that company. The owner's own login is untouched, so stopping is just
 * forgetting the token. Kept in sessionStorage: it ends with the tab.
 */
const KEY = 'wk_act_as';

export const getActAs = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.token || !data.expiresAt || new Date(data.expiresAt) <= new Date()) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

/** `data` is the act-as response: { token, expiresAt, organization: { id, slug, name, logoUrl, colors } } */
export const startActAs = (data) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* storage unavailable */ }
};

export const stopActAs = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
};

/** The header to add to API calls, or nothing. */
export const actAsHeader = () => {
  const a = getActAs();
  return a ? { 'X-WK-Act-As': a.token } : {};
};

/** The slug of the company being acted as, or null. */
export const actAsSlug = () => getActAs()?.organization?.slug || null;

/** Minutes left on the act-as session (0 when none). */
export const actAsMinutesLeft = () => {
  const a = getActAs();
  return a ? Math.max(0, Math.round((new Date(a.expiresAt) - Date.now()) / 60000)) : 0;
};
